import type {Dispatch, SetStateAction} from 'react';
import React from 'react';

import {Placeholder} from '@storybook/components';

import Accordeon from './Accordeon';
import {useIssues} from './hooks/useIssues';

interface ComponentProps {
    active: boolean;
    setUpdated: Dispatch<SetStateAction<number>>;
    storyId: string;
    updated: number;
}

/**
 * IssueList.
 *
 * @param props            Component props.
 * @param props.storyId    The story id.
 * @param props.updated    Triggers an update.
 * @param props.setUpdated The set updated.
 * @param props.active     Whether the panel is active.
 * @returns The component.
 */
const IssueList = ({active, setUpdated, storyId, updated}: ComponentProps) => {
    const {error, issues} = useIssues(storyId, updated, active);

    return (
        <>
            {error && <Placeholder>{error}</Placeholder>}
            {!error && (
                issues.map(issue => (
                    <Accordeon key={issue.id} issue={issue} setUpdated={setUpdated} />
                ))
            )}
            {!error && !issues.length && (
                <Placeholder>No issues so far. (Click on Create Issue to give the first feedback)</Placeholder>
            )}
        </>
    );
};

IssueList.displayName = 'IssueList';

export default IssueList;